export default {
  apiKey: "AIzaSyCiciDVq2tFzyI35hg0mGap7r-m5JFMyps",
  authDomain: "themoney-news-admin.firebaseapp.com",
  databaseURL: "https://themoney-news-admin.firebaseio.com",
  projectId: "themoney-news-admin",
  storageBucket: "themoney-news-admin.appspot.com",
  messagingSenderId: "678842405195",
  appId: "1:678842405195:web:a8732be454ee9e723418ce",
};
